import { Map } from 'immutable';
import { RECIEVE_MESSAGE, RECIEVE_MESSAGES } from './actions/Message';

const initialState = Map({
  messages: {},
});

const MessageReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case RECIEVE_MESSAGES: {
      return state.setIn(['messages', action.objectId], action.messages);
    }
    case RECIEVE_MESSAGE: {
      return state.updateIn(['messages', action.objectId], messages =>
        messages ? messages.concat(action.message) : [action.message]);
    }
    default:
      return state;
  }
};

export default MessageReducer;



// WEBPACK FOOTER //
// ./src/redux/MessageReducer.js